// extracted by css-extract-rspack-plugin
export default {"FieldLabel":"U379s","Footer":"XFjKp","RemoveLink":"DNa0j"};